import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useState, useMemo, useEffect } from "react"
import {
  FaChevronLeft,
  FaChevronRight,
  FaEdit,
  FaFileImport,
  FaPlus,
  FaSave,
} from "react-icons/fa"
import { MdCancel, MdDelete } from "react-icons/md"
import {
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"

const Brand = () => {
  // State
  const [brand, setbrand] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [editingbrand, seteditingbrand] = useState(null)
  const [searchText, setSearchText] = useState("")
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(10)

  const [loading, setLoading] = useState(false)

  /* ================= SAMPLE DATA ================= */
  useEffect(() => {
    getCategory()
  }, [])

  async function getCategory() {
    const APIdata = await fetchData(setLoading, "brand")
    if (APIdata?.success) {
      setbrand(APIdata?.data)
    }
  }

  // Toggle modal
  const toggleModal = () => setModalOpen(!modalOpen)

  // Open modal for Edit
  const handleEdit = dept => {
    seteditingbrand(dept)
    toggleModal()
  }

  // Save Category
  const handleSave = async () => {
    if (!editingbrand?.brandName?.trim()) {
      Swal.fire({ title: "Brand name is required", icon: "warning" })
      return
    }
    if (editingbrand?.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "brand",
        editingbrand?.id,
        editingbrand
      )
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Brand Updated Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          getCategory()
        }, 1500)
      } else {
        Swal.fire({
          title: "Error Adding Brand",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(setLoading, "brand", editingbrand)
      if (APIdata?.data?.success) {
        setModalOpen(false)
        Swal.fire({
          title: "Brand Added Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })
        setTimeout(() => {
          getCategory()
        }, 1500)
      } else {
        Swal.fire({
          title: "Error Adding Brand",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
  }

  const handleDelete = async item => {
    const confirm = await Swal.fire({
      title: "Are you Sure?",
      text: `you want to Delete this ${item?.brandName} Brand`,
      icon: "warning",
      showCancelButton: true,
    })

    if (!confirm.isConfirmed) {
      return
    }
    const APIdata = await FetchDeleteData(setLoading, "brand", item?.id)
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Brand Deleted Successfully",
        text: APIdata?.data?.message,
        icon: "success",
      })
      setTimeout(() => {
        getCategory()
      }, 1500)
    } else {
      Swal.fire({
        title: "Error deleting Role",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  // Filtered & paginated category
  const filteredDepts = useMemo(
    () =>
      brand.filter(d =>
        d?.brandName?.toLowerCase().includes(searchText.toLowerCase())
      ),
    [brand, searchText]
  )

  const totalPages = Math.ceil(filteredDepts.length / perPage)
  const paginatedDepts = filteredDepts.slice(
    (page - 1) * perPage,
    page * perPage
  )

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Settings" breadcrumbItem="Brand" />
      <Card>
        <CardBody>
          {/* ===== FILTER BAR ===== */}
          <div className="d-flex justify-content-between mb-3">
            <div className="d-flex gap-3">
              <select
                className="form-select"
                style={{ width: "100px" }}
                value={perPage}
                onChange={e => {
                  setPerPage(Number(e.target.value))
                  setPage(1)
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>

              <Input
                placeholder="Search..."
                value={searchText}
                onChange={e => {
                  setSearchText(e.target.value)
                  setPage(1)
                }}
              />
            </div>

            <Button
              className="btn-blue"
              onClick={() => {
                toggleModal(), seteditingbrand({})
              }}
            >
              <FaPlus className="me-1" />
              Add
            </Button>
          </div>

          <Table bordered responsive hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Brand Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedDepts.length > 0 ? (
                paginatedDepts.map((dept, index) => (
                  <tr key={dept.id}>
                    <td>{(page - 1) * perPage + index + 1}</td>
                    <td>{dept.brandName}</td>
                    <td>
                      <Button
                        color="warning"
                        className="me-2"
                        onClick={() => handleEdit(dept)}
                      >
                        <FaEdit />
                      </Button>
                      <Button color="danger" onClick={() => handleDelete(dept)}>
                        <MdDelete />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    No Brand found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* ===== PAGINATION ===== */}
          <div className="d-flex justify-content-between">
            <span className="align-self-center">
              Page {page} of {totalPages || 1}
            </span>
            {/* ===== PAGINATION ===== */}
            <div className="d-flex justify-content-center align-items-center gap-2 ">
              {/* Previous */}
              <Button
                disabled={page === 1}
                onClick={() => setPage(prev => prev - 1)}
                className="btn-blue"
              >
                <FaChevronLeft />
              </Button>

              {/* Page Numbers (Show 5 at a time) */}
              {(() => {
                const pageNumbers = []
                const maxVisiblePages = 5

                let startPage = Math.max(
                  1,
                  page - Math.floor(maxVisiblePages / 2)
                )

                let endPage = startPage + maxVisiblePages - 1

                if (endPage > totalPages) {
                  endPage = totalPages
                  startPage = Math.max(1, endPage - maxVisiblePages + 1)
                }

                for (let i = startPage; i <= endPage; i++) {
                  pageNumbers.push(
                    <Button
                      key={i}
                      color={page === i ? "primary" : "light"}
                      onClick={() => setPage(i)}
                    >
                      {i}
                    </Button>
                  )
                }

                return pageNumbers
              })()}

              {/* Next */}
              <Button
                disabled={page === totalPages || totalPages === 0}
                onClick={() => setPage(prev => prev + 1)}
                className="btn-blue"
              >
                <FaChevronRight />
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Add/Edit Modal */}
      <Modal isOpen={modalOpen} centered>
        <ModalHeader toggle={toggleModal}>
          {editingbrand?.id ? "Edit Brand" : "Add Brand"}
        </ModalHeader>
        <ModalBody>
          <Form>
            <Label>Brand Name</Label>
            <Input
              type="text"
              value={editingbrand?.brandName || ""}
              onChange={e =>
                seteditingbrand(prev => ({
                  ...prev,
                  brandName: e.target.value.replace(/^\s+/, ""),
                }))
              }
            />
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-blue" onClick={handleSave}>
            <FaSave /> Save
          </Button>{" "}
          <Button color="secondary" onClick={toggleModal}>
            <MdCancel /> Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default Brand
